export const paths = ['/time-card'];
